export default function getTooltipInitiation(unit) {
    return {
        visible: false,
        year: null,
        data: [],
        x: 0,
        y: 0,
    }
}